import { Button, Col, Row, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { saveAs } from 'file-saver';
import {
  ContractMatchParams,
  contractType1Enum,
  getContractList2Async,
} from '../../modules/contracts';
import Title from 'antd/lib/typography/Title';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import PDFViewModal2 from '../../components/expenses/PDFViewModal2';
import PrimeContractDetailComponent from '../../components/contracts/PrimeContractDetailComponent';

function PrimeContractDetailContainer({
  history,
  match,
}: RouteComponentProps<ContractMatchParams>) {
  const { enterpriseId, projectId } = match.params;
  const [pdfFile, setPdfFile] = useState<any>();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getContractList2Async.request({
        enterpriseId,
        projectId,
        contractType1: contractType1Enum.PRIME_CONTRACT,
      }),
    );
  }, [dispatch, enterpriseId, projectId]);

  const {
    data: primeContractData,
    loading,
    error,
  } = useSelector((state: RootState) => state.contracts.contract);

  const moveToPrimeContractEditPage = (contractId: number) => {
    history.push(`primeContracts/${contractId}/edit`);
  };

  const _downloadPdf = () => {
    saveAs(pdfFile.url, `${pdfFile.name}`);
  };

  const openPdfFile = (file: any) => {
    setPdfFile(file);
  };

  return (
    <>
      {loading && <Spin />}
      {error && <p style={{ textAlign: 'center' }}>에러 발생!</p>}

      {primeContractData && (
        <>
          <Title level={3}>{primeContractData.title}</Title>
          {/* <Tabs>
            <TabPane tab="일반" key="1"> */}
          {primeContractData && (
            <PrimeContractDetailComponent
              data={primeContractData}
              moveToContractEditPage={moveToPrimeContractEditPage}
              openPdfFile={openPdfFile}
            ></PrimeContractDetailComponent>
          )}
          {/* </TabPane>
            <TabPane tab="내역서" key="2"> */}
          {/* <PrimeContractCostDetailComponent /> */}
          {/* <PrimeContractSOVDetailContainer
                enterpriseId={enterpriseId}
                projectId={projectId}
                contractId={contractId}
                moveToSOVEditPage={moveToSOVEditPage}
                moveToPrintPage={moveToPrintPage}
              ></PrimeContractSOVDetailContainer> */}
          {/* </TabPane>
          </Tabs> */}
        </>
      )}
      {primeContractData === null && (
        <>
          <Row
            justify={'center'}
            style={{ marginTop: '40px', marginBottom: '20px' }}
          >
            <Col>
              <Title level={5}>도급 계약을 추가 해 주세요.</Title>
            </Col>
          </Row>
          <Row justify={'center'}>
            <Col>
              <Button onClick={() => history.push('primeContracts/create')}>
                도급계약 추가
              </Button>
            </Col>
          </Row>
        </>
      )}
      {pdfFile && (
        <PDFViewModal2
          visible={!!pdfFile}
          url={pdfFile.url}
          onCancel={() => setPdfFile(null)}
          onDownload={_downloadPdf}
        />
      )}
    </>
  );
}

export default withRouter(PrimeContractDetailContainer);
